import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalTrimmedNullableEmail, optionalTrimmedNullableString, rejectPhoneContextInjection, } from '../zod-helpers/index.js';
import { CONTACT_CONSTRAINTS } from './constraints.js';
import { CONTACT_PREFERRED_METHODS } from './preferred-method/index.js';
export const contactNameSchema = z
    .string()
    .trim()
    .min(1, `${capitalize(CONTACT_CONSTRAINTS.contactName.label.toLowerCase())} is required.`)
    .max(CONTACT_CONSTRAINTS.contactName.maxLength);
export const contactPreferredMethodSchema = z.enum(CONTACT_PREFERRED_METHODS, 'Invalid preferred contact method.');
// typeId is omitted: create resolvers set ContactType.MAIN server-side.
export const createContactInputSchema = z.object({
    contactName: contactNameSchema,
    title: optionalTrimmedNullableString(CONTACT_CONSTRAINTS.title.maxLength),
    email: optionalTrimmedNullableEmail(CONTACT_CONSTRAINTS.email.maxLength, `Invalid ${CONTACT_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: rejectPhoneContextInjection(optionalTrimmedNullableString(CONTACT_CONSTRAINTS.phone.maxLength)),
    preference: contactPreferredMethodSchema.optional().nullable(),
    defaultFlag: z.boolean().optional().nullable(),
});
//# sourceMappingURL=create-input.js.map